import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import ICalendarLink from "react-icalendar-link";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";

import { allSharedComponents } from "../../../../../shared";
import { buttonTextHandler, getSportNameById } from "./../utilities";
import {
  calculateVAT,
  CommaSplitToTranslatedCommaJoined,
  formatDateTimeRangeFromServer,
  precisionCalculation,
  unloadWidget,
} from "../../../../../system";
import {
  dateToUTCWithTimezone,
  getUserPayload,
  moveBack,
  serverFormatToMomentObject,
  toSingleDateStringIfEqual,
} from "../../../../../system";
import {
  authActions,
  competitionActions,
  paymentActions,
  SubscriptionActions,
} from "../../../../../redux/actions";
import {
  DirectionIcon,
  ArrowLeftIcon,
  TimeIcon,
} from "../../../../../assets/images/icon";
import {
  translationConstants,
  systemConstants,
  viewPathConstants,
  Directions,
  competitionConstants,
  paymentType,
  subscriptionTypeConstants,
  timezoneConstants,
  genderEnumReversed,
  calculationOperations,
} from "../../../../../constants";

const {
  CustomModal,
  BaseForm,
  RegistrationPaymentModal,
  BoatClassPaymentModal,
} = allSharedComponents;

const DetailCompetition = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userPayload = getUserPayload();

  const queryParams = new URLSearchParams(location.search);
  const paramId = queryParams.get("id");
  const paramFlag = queryParams.get("id");
  const competitionId = paramId ? paramId : location.state.competitionId;
  const flag = paramFlag ? paramFlag : location.state.flag;

  const [city, setCity] = useState();
  const [isShow, setShow] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [registrationPrice, setRegistrationPrice] = useState(0);

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const competitionDataById = useSelector((state) => {
    return state.CompetitionReducer.competitionPublicDataById;
  });
  const isAuthenticated = useSelector(
    (state) => state.LoginReducer.isAuthenticated
  );
  const isParticipantsValidated = useSelector(
    (state) => state.CompetitionReducer?.isParticipantsValidated
  );
  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );
  const cities = useSelector((state) => state.LoginReducer.cities);
  const sportType = getSportNameById(competitionDataById?.sportId);

  const classes = competitionDataById?.classes
    ?.map((boat) => {
      const name =
        direction === Directions.rtl && boat.arabicName
          ? boat.arabicName
          : boat.name;
      const genderText = t(
        translationConstants[genderEnumReversed[boat.gender]]
      );
      return `${name} - ${genderText}`;
    })
    .join(", ");

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    // eslint-disable-next-line
  }, [dispatch, competitionDataById]);

  useEffect(() => {
    const findCity = cities?.find((c) => c.id === competitionDataById?.cityId);
    setCity(findCity);
    // eslint-disable-next-line
  }, [cities, competitionDataById]);

  useEffect(() => {
    if (isParticipantsValidated) {
      onSetShow();
    }
    // eslint-disable-next-line
  }, [isParticipantsValidated]);

  const resetAllStates = () => {
    unloadWidget();
    setSelectedCompetition(null);
    dispatch(paymentActions.paymentCheckoutNull());
    dispatch(competitionActions.validateParticipentsForCompetitionFalse());
  };

  const onSetShow = () => {
    setShow((prev) => !prev);
    if (isShow) {
      resetAllStates();
    }
    if (!isAuthenticated) {
      dispatch(authActions.setShowLoginModal(true));
      dispatch(authActions.setLoginFromRegistration(true));
      setSelectedCompetition(null);
    }
  };

  const navigateToLeaderboard = () => {
    navigate(`${viewPathConstants.COMPETITION_LEADERBOARD}`, {
      state: { competition: competitionDataById },
    });
  };

  useEffect(() => {
    if (selectedCompetition) {
      if (isAuthenticated) {
        dispatch(
          competitionActions.validateParticipentsForCompetition(
            userPayload?.user?.id,
            selectedCompetition,
            setSelectedCompetition
          )
        );
      } else {
        onSetShow();
      }
    }
    // eslint-disable-next-line
  }, [selectedCompetition, isAuthenticated, dispatch]);

  useEffect(() => {
    dispatch(competitionActions.getPublicCompetitionById(competitionId));
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  const icsEvent = {
    title: competitionDataById?.title,
    description: competitionDataById?.description,
    startTime: moment(
      competitionDataById?.startDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    endTime: moment(
      competitionDataById?.endDateString,
      timezoneConstants.dateTimeFormatForServer
    ).toISOString(),
    location: `${competitionDataById?.spotInfo?.spotName}`,
  };

  useEffect(() => {
    const vat = subscriptionPrices?.find(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );
    if (competitionDataById?.registrationFee && vat) {
      const totalPrice = precisionCalculation(
        calculateVAT(vat?.price, competitionDataById?.registrationFee),
        competitionDataById?.registrationFee,
        calculationOperations.addition
      );
      setRegistrationPrice(totalPrice);
    }
    // eslint-disable-next-line
  }, [competitionDataById, subscriptionPrices]);

  return (
    <>
      <div className="container move-back">
        <span className="cursor-pointer" onClick={moveBack}>
          <img
            src={ArrowLeftIcon}
            className="rotated-element"
            alt="backArrowIcon"
          />
        </span>
      </div>
      {competitionDataById && Object.keys(competitionDataById).length > 0 && (
        <div className="container">
          <Row className="detail-competition-wrapper p-2 p-md-4">
            <Col sm={12} className="pb-4">
              {competitionDataById?.posters && (
                <img
                  alt="info-icon"
                  src={competitionDataById?.posters?.link}
                  className="w-100 poster-style"
                />
              )}
            </Col>
            <Col sm={12} md={12} lg={7} className="">
              <div className="mb-3">
                <div className="pt-4 d-flex flex-column gap-2">
                  <h3 className="fw-bolder">
                    {direction === Directions.rtl &&
                    competitionDataById?.arabicTitle
                      ? `${competitionDataById?.arabicTitle}`
                      : `${competitionDataById?.title}`}
                  </h3>
                </div>
                <div className="d-flex flex-column">
                  <h5 className="font-18 fw-bold">
                    {t(translationConstants[sportType])}
                  </h5>
                  <h5 className="font-16 text-muted">{classes}</h5>
                </div>
                <div className="d-flex flex-column">
                  <h5 className="font-16">
                    {toSingleDateStringIfEqual(
                      competitionDataById?.startDateString,
                      competitionDataById?.endDateString
                    )}
                  </h5>
                  <h5 className="font-16">
                    <img alt="" name="activityDate" src={TimeIcon} />
                    <span>
                      {formatDateTimeRangeFromServer(
                        competitionDataById?.startDateString,
                        competitionDataById?.endDateString,
                        timezoneConstants.hourMinuteFormat
                      )}
                    </span>
                  </h5>
                </div>
                <div className="mt-3">
                  {flag === competitionConstants.UPCOMING &&
                    competitionDataById?.isPublicRegistrationAllowed && (
                      <>
                        {!(
                          competitionDataById?.registrationStartsInDays < 0 &&
                          competitionDataById?.registrationEndsInDays < 0
                        ) &&
                          (dateToUTCWithTimezone().isBefore(
                            serverFormatToMomentObject(
                              competitionDataById?.registrationStartDateString
                            )
                          ) ? (
                            <span
                              className={`timeLogDesign text-center text-md-start 
                                "font-14"`}
                            >
                              {competitionDataById?.registrationStartsInDays > 1
                                ? `${t(
                                    translationConstants.registration_starts_in
                                  )} ${
                                    competitionDataById?.registrationStartsInDays
                                  } ${t(translationConstants.days)}`
                                : competitionDataById?.registrationStartsInDays ===
                                  1
                                ? `${t(
                                    translationConstants.registration_starting_tomorrow
                                  )}`
                                : `${t(
                                    translationConstants.registration_starting_today
                                  )}`}
                            </span>
                          ) : (
                            <span
                              className={`timeLogDesign text-center text-md-start font-14"`}
                            >
                              {competitionDataById?.registrationEndsInDays > 1
                                ? `${t(
                                    translationConstants.registration_ending_in
                                  )} ${
                                    competitionDataById?.registrationEndsInDays
                                  } ${t(translationConstants.days)}`
                                : competitionDataById?.registrationEndsInDays ===
                                  1
                                ? `${t(
                                    translationConstants.registration_ending_tomorrow
                                  )}`
                                : `${t(
                                    translationConstants.registration_ending_today
                                  )}`}
                            </span>
                          ))}
                      </>
                    )}
                </div>
              </div>
            </Col>
            <Col
              sm={12}
              md={12}
              lg={5}
              className="col-lg-5 px-md-3 px-0 mt-2 d-flex  gap-md-3 gap-2 align-items-start justify-content-md-end mb-5"
            >
              {flag === competitionConstants.UPCOMING &&
                !(
                  competitionDataById?.registrationStartsInDays < 0 &&
                  competitionDataById?.registrationEndsInDays < 0
                ) && (
                  <>
                    {competitionDataById?.maximumParticipantsAllowed > 0 &&
                      competitionDataById?.isPublicRegistrationAllowed && (
                        <div>
                          <div
                            className={`seatsAvailableCard-light h-120px w-100px gap-2 px-md-2 px-3 py-4 flex-grow-1`}
                          >
                            <h1 className="m-0 p-0 fw-700">
                              {competitionDataById?.seatsAvailable}
                            </h1>
                            <h6 className="font-12 text-center">
                              {t(translationConstants.SEATS_AVAILABLE)}
                            </h6>
                          </div>
                        </div>
                      )}
                  </>
                )}
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div
                  className={`${
                    competitionDataById?.registrationStartsInDays < 0 &&
                    competitionDataById?.registrationEndsInDays < 0
                      ? competitionDataById?.registrationFee !== null &&
                        "seatsAvailableCard-light"
                      : "seatsAvailableCard-light"
                  } h-120px px-md-4 px-3 py-4 flex-grow-1 gap-2`}
                >
                  {competitionDataById?.isPublicRegistrationAllowed &&
                    flag !== "previous" &&
                    competitionDataById?.registrationFee !== null && (
                      <div className="text-center">
                        <h6 className="font-16 fw-600 m-0 p-0">
                          {t(translationConstants.registration_fees)}
                        </h6>
                        <h5 className="font-16 fw-bold m-0 mt-1">{`${translationConstants.SAR} ${registrationPrice}`}</h5>
                      </div>
                    )}
                  {flag === competitionConstants.UPCOMING ? (
                    !dateToUTCWithTimezone().isAfter(
                      serverFormatToMomentObject(
                        competitionDataById?.registrationEndDateString
                      )
                    ) ? (
                      <>
                        <Button
                          className={
                            !competitionDataById?.isPublicRegistrationAllowed ||
                            competitionDataById?.seatsAvailable <= 0
                              ? "registration-invite-only"
                              : dateToUTCWithTimezone().isSameOrAfter(
                                  serverFormatToMomentObject(
                                    competitionDataById?.registrationStartDateString
                                  )
                                )
                              ? "registration-ending"
                              : "registration-openning"
                          }
                          disabled={
                            competitionDataById?.seatsAvailable <= 0 ||
                            dateToUTCWithTimezone().isBefore(
                              serverFormatToMomentObject(
                                competitionDataById?.registrationStartDateString
                              )
                            ) ||
                            !competitionDataById?.isPublicRegistrationAllowed
                          }
                          onClick={() => {
                            setSelectedCompetition(competitionDataById?.id);
                          }}
                        >
                          {buttonTextHandler(t, competitionDataById)}
                        </Button>
                      </>
                    ) : (
                      <h6 className="font-14 fw-600 underline">
                        {t(translationConstants.REGISTRATION_CLOSED)}
                      </h6>
                    )
                  ) : competitionDataById?.isScorePublished ? (
                    <>
                      <h5>{t(translationConstants.competition_is_ended)}</h5>
                      <Button
                        className="btn-submit m-0"
                        onClick={() => {
                          navigateToLeaderboard();
                        }}
                      >
                        {t(translationConstants.VIEW_RESULT)}
                      </Button>
                    </>
                  ) : (
                    <Button
                      className="registration-invite-only m-0 customBtnforCompetionInProgress"
                      disabled={true}
                    >
                      {t(translationConstants.SCORE_NOT_PUBLISHED)}
                    </Button>
                  )}
                </div>
              </div>
            </Col>
            <div>
              <Row>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.LOCATION)}:
                    </h5>
                  </div>
                  <div>
                    <a
                      href={
                        competitionDataById?.spotInfo
                          ? undefined
                          : `https://maps.google.com/?q=${competitionDataById?.lat},${competitionDataById?.long}`
                      }
                      onClick={(e) => {
                        if (competitionDataById?.spotInfo) {
                          e.preventDefault(); // Prevent default link behavior
                          navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
                            state: {
                              centerId: competitionDataById?.spotInfo?.id,
                            },
                          });
                        }
                      }}
                      target="_blank"
                      className="font-16 center-card-view-detail-link"
                    >
                      <img src={DirectionIcon} alt="get directions icon" />
                      {direction === Directions.rtl
                        ? competitionDataById?.spotInfo?.arabicSpotName ||
                          competitionDataById?.spotInfo?.spotName
                        : competitionDataById?.spotInfo?.spotName}
                      {direction === Directions.rtl
                        ? city?.arabicName || city?.name
                        : city?.name}
                    </a>
                  </div>
                </Col>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.AGE_LIMIT)}:
                    </h5>
                  </div>
                  <div>
                    <p className="font-16">{` ${
                      competitionDataById?.minAge
                    } - ${competitionDataById?.maxAge} ${t(
                      translationConstants.YEARS
                    )}`}</p>
                  </div>
                </Col>
                <Col sm={12} md={3} className="pb-3">
                  <div>
                    <h5 className="font-18 fw-bolder">
                      {t(translationConstants.important_documents)}:
                    </h5>
                  </div>
                  <div>
                    <a
                      href={competitionDataById?.nor?.link}
                      target="_blank"
                      className="font-16 underline"
                    >
                      {t(translationConstants.NOTICE_OF_RACE)}
                    </a>
                  </div>
                </Col>
              </Row>
              <Col sm={12} md="auto" className="">
                {competitionDataById?.providedServices && (
                  <div>
                    <h6 className="font-18 fw-bolder">
                      {t(translationConstants.SERVICES)}:
                    </h6>
                    <p className="font-16 w-75">
                      {CommaSplitToTranslatedCommaJoined(
                        competitionDataById?.providedServices,
                        t
                      )}
                    </p>
                  </div>
                )}
              </Col>
              {competitionDataById?.description && (
                <div className="py-4 d-flex flex-column gap-2">
                  <span className="font-18 fw-bolder">
                    {t(translationConstants.DESCRIPTION)}:
                  </span>
                  <span className="second-card-description-text w-75 text-break">
                    {direction === systemConstants.DIRECTION_RIGHT_TO_LEFT &&
                    competitionDataById?.arabicDescription
                      ? competitionDataById?.arabicDescription
                      : competitionDataById?.description}
                  </span>
                </div>
              )}
              <div className="mt-20px">
                {competitionDataById?.isPublicRegistrationAllowed && (
                  <a
                    target="_blank"
                    disabled={true}
                    className="d-none font-14 underline center-card-view-detail-link approved-color cursor-not-allowed"
                  >
                    {t(translationConstants.VIEW_CANCELLATION_POLICY)}
                  </a>
                )}
              </div>
              <div>
                <span
                  target="_blank"
                  disabled={true}
                  className="font-14 center-card-view-detail-link approved-color"
                >
                  <ICalendarLink
                    event={icsEvent}
                    filename={competitionDataById?.title}
                  >
                    {t(translationConstants.add_to_calendar)}
                  </ICalendarLink>
                </span>
              </div>
            </div>

            {isAuthenticated && (
              <CustomModal
                size="sm"
                show={isShow}
                scrollable={true}
                setShow={onSetShow}
              >
                {competitionDataById?.registrationFee ? (
                  <BaseForm customClass="payment-modal-min-height">
                    <RegistrationPaymentModal
                      title={t(translationConstants.REGISTER_FOR_COMPETITION)}
                      eventID={competitionDataById?.id}
                      type={paymentType.Competition}
                    />
                  </BaseForm>
                ) : (
                  <BaseForm customClass="free-competition-payment-modal">
                    <BoatClassPaymentModal
                      setShow={setShow}
                      onSuccess={() => {
                        resetAllStates();
                        navigate(-1);
                      }}
                      resetAllStates={resetAllStates}
                      selectedCompetition={selectedCompetition}
                    />
                  </BaseForm>
                )}
              </CustomModal>
            )}
          </Row>
        </div>
      )}
    </>
  );
};

export default DetailCompetition;
